/**
 * A custom initiator got executed.
 */
export const INITIATOR_EXECUTION = "RCB/Initiator/Execution";